// 목록 화면 합계 - 카드 대신 건조한 한 줄 텍스트(가운뎃점 구분).
// /chancemng 프로토타입(2026-10-22, fc30533)의 ChanceTotalSummary.js에서 추출.
// items: [{ label, value, color? }] - color는 MUI palette key(예: 'success.main') 또는 비우면 text.primary.
import { Fragment } from 'react';
import { Box, Typography } from '@mui/material';

const TotalsLine = ({ items = [], className = 'total-summary', sx = {} }) => {
  if (!items.length) return null;
  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'baseline',
        justifyContent: { xs: 'flex-start', sm: 'flex-end' },
        rowGap: 0.5,
        width: '100%',
        px: 0.5,
        ...sx,
      }}
    >
      {items.map((it, i) => (
        <Fragment key={it.label}>
          {i > 0 && (
            <Typography component="span" variant="body2" color="text.disabled" sx={{ mx: 1.25 }}>
              ·
            </Typography>
          )}
          <Typography component="span" variant="caption" color="text.secondary" sx={{ mr: 0.75 }}>
            {it.label}
          </Typography>
          <Typography
            component="span"
            variant="body2"
            sx={{
              fontWeight: 600,
              fontVariantNumeric: 'tabular-nums',
              color: it.color || 'text.primary',
            }}
          >
            {it.value}
          </Typography>
        </Fragment>
      ))}
    </Box>
  );
};

export default TotalsLine;
